<template>
  <section class="checkout" :class="stepClass" ref="checkout">
    <h1 class="visually-hidden">Checkout</h1>

    <Steps />

    <div class="checkout-container container-fluid" :class="{'checkout-containerTs': data.brandNameFormatted === Brand.Travelsphere}">
      <div class="checkout-row row">
        <keep-alive>
          <PlaneLoader v-if="loading" :brandName=data.brandNameFormatted />

          <div class="checkout-global-error" v-else-if="error">
            <div class="error-message">
              <div class="error-message__icon"></div>
              <div class="error-message__text">
                <h2>{{data.bookingError.title}}</h2>
                <h3 v-if="quoteData.quoteId">Your quote id: {{quoteData.quoteId}}</h3>
                <p v-if="errorMessage">{{errorMessage}}</p>
                <div v-html="data.bookingError.descriptionHtml"></div>
              </div>
            </div>
          </div>

          <slot v-else :name="currentStepName" />
        </keep-alive>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Steps from './Components/Steps.vue';
import PlaneLoader from './Components/PlaneLoader.vue';
import {Brand} from './../../../brand.js';

export default {
  components: {
    Steps,
    PlaneLoader
  },

  props: ['data', 'quote'],

  data: function() {
    return {
      Brand
    };
  },

  computed: {
    ...mapState('checkout', ['loading', 'error', 'errorMessage']),
    ...mapState('checkout', {
      quoteData: 'quote'
    }),
    ...mapGetters('checkout', ['currentStepName']),

    stepClass() {
      if (!this.loading) {
        return `checkout-${this.currentStepName}`;
      }
    }
  },

  created() {
    this.$store.commit('checkout/setIsCheckoutPage', true);
    this.$store.commit('checkout/setData', this.data);
    this.$store.commit('checkout/setQuote', this.quote);
    this.$store.commit('checkout/setQuoteDonations');

    this.$store.dispatch('checkout/getVisas');

    if (this.data.login.userIsLoggedIn) {
      this.$store.dispatch('checkout/getLoggedInPassengerData');
    }
  },

  watch: {
    error(newError) {
      if (newError) {
        GTM.checkoutError(this.data.bookingError.title);
      }
    }
  }
};
</script>
